module.exports = __webpack_public_path__ + "img/item2.cdc332b3.png";